/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DailyTasksRouteImport } from './routes/daily-tasks'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EventsIndexRouteImport } from './routes/events/index'
import { Route as EventsWantedBossRouteImport } from './routes/events/wanted-boss'
import { Route as EventsArmsRaceRouteImport } from './routes/events/arms-race'
import { Route as EventsAllianceDuelRouteImport } from './routes/events/alliance-duel'

const DailyTasksRoute = DailyTasksRouteImport.update({
  id: '/daily-tasks',
  path: '/daily-tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsWantedBossRoute = EventsWantedBossRouteImport.update({
  id: '/events/wanted-boss',
  path: '/events/wanted-boss',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsArmsRaceRoute = EventsArmsRaceRouteImport.update({
  id: '/events/arms-race',
  path: '/events/arms-race',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsAllianceDuelRoute = EventsAllianceDuelRouteImport.update({
  id: '/events/alliance-duel',
  path: '/events/alliance-duel',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/daily-tasks': typeof DailyTasksRoute
  '/events/alliance-duel': typeof EventsAllianceDuelRoute
  '/events/arms-race': typeof EventsArmsRaceRoute
  '/events/wanted-boss': typeof EventsWantedBossRoute
  '/events': typeof EventsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/daily-tasks': typeof DailyTasksRoute
  '/events/alliance-duel': typeof EventsAllianceDuelRoute
  '/events/arms-race': typeof EventsArmsRaceRoute
  '/events/wanted-boss': typeof EventsWantedBossRoute
  '/events': typeof EventsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/daily-tasks': typeof DailyTasksRoute
  '/events/alliance-duel': typeof EventsAllianceDuelRoute
  '/events/arms-race': typeof EventsArmsRaceRoute
  '/events/wanted-boss': typeof EventsWantedBossRoute
  '/events/': typeof EventsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/daily-tasks'
    | '/events/alliance-duel'
    | '/events/arms-race'
    | '/events/wanted-boss'
    | '/events'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/daily-tasks'
    | '/events/alliance-duel'
    | '/events/arms-race'
    | '/events/wanted-boss'
    | '/events'
  id:
    | '__root__'
    | '/'
    | '/daily-tasks'
    | '/events/alliance-duel'
    | '/events/arms-race'
    | '/events/wanted-boss'
    | '/events/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DailyTasksRoute: typeof DailyTasksRoute
  EventsAllianceDuelRoute: typeof EventsAllianceDuelRoute
  EventsArmsRaceRoute: typeof EventsArmsRaceRoute
  EventsWantedBossRoute: typeof EventsWantedBossRoute
  EventsIndexRoute: typeof EventsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/daily-tasks': {
      id: '/daily-tasks'
      path: '/daily-tasks'
      fullPath: '/daily-tasks'
      preLoaderRoute: typeof DailyTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/wanted-boss': {
      id: '/events/wanted-boss'
      path: '/events/wanted-boss'
      fullPath: '/events/wanted-boss'
      preLoaderRoute: typeof EventsWantedBossRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/arms-race': {
      id: '/events/arms-race'
      path: '/events/arms-race'
      fullPath: '/events/arms-race'
      preLoaderRoute: typeof EventsArmsRaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/alliance-duel': {
      id: '/events/alliance-duel'
      path: '/events/alliance-duel'
      fullPath: '/events/alliance-duel'
      preLoaderRoute: typeof EventsAllianceDuelRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DailyTasksRoute: DailyTasksRoute,
  EventsAllianceDuelRoute: EventsAllianceDuelRoute,
  EventsArmsRaceRoute: EventsArmsRaceRoute,
  EventsWantedBossRoute: EventsWantedBossRoute,
  EventsIndexRoute: EventsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
